<script lang="ts" setup>
defineProps<{ amount: number | null }>();
</script>

<template>
  <div
    v-if="amount"
    class="loyalty-badge"
  >
    {{ amount }}

    <SvgoLoyaltyF
      :font-controlled="false"
      class="loyalty-badge__icon"
      filled
    />
  </div>
</template>

<style lang="scss" scoped>
.loyalty-badge {
  display: flex;
  flex-shrink: 0;
  flex-wrap: nowrap;
  gap: 4px;
  justify-content: center;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  background-color: $black;
  color: $white;
  font-size: $text-3xs;
  line-height: 1;

  @include screen-sm {
    font-size: $text-2xs;
  }

  &__icon {
    width: 14px;
    height: 14px;
  }
}
</style>
